<div class="container" *ngIf="inhousePharmacyDetails$ | async as details">
  <div class="loading-overlay" *ngIf="details.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div class="container__form" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="id340bInput" text="Search by 340B ID">
        </kendo-label>
        <kendo-textbox
          #id340bInput
          class="form-field"
          formControlName="id340b"
          (keydown.Enter)="getInhousePharmacyDetails()"
          (keydown.Tab)="getInhousePharmacyDetails()"
        >
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div class="control-wrap search-btn">
      <button
        kendoButton
        [primary]="true"
        (click)="getInhousePharmacyDetails()"
      >
        <span class="k-icon k-font-icon k-i-search"></span>
        Search
      </button>
      <p *ngIf="lastSearchDate" class="search-date">
        Last searched {{ lastSearchDate | date: dateTimeFormat }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="searchSubmitted">
    <div class="container__no-data" *ngIf="!details.data">
      No in-house pharmacy data
    </div>

    <section class="container__details" *ngIf="details.data as detailsData">
      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="340B ID"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.id340b }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="CE ID"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.ce_id }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Parent CE ID">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.parent_ce_id }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Site ID"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.site_id }}</span>
        </div>
      </div>

      <div class="detail-field span-4">
        <kendo-label class="detail-field__label" text="Name"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.ce_name }}</span>
        </div>
      </div>

      <div class="detail-field span-4">
        <kendo-label class="detail-field__label" text="Sub Name"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.ce_sub_name }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Address Line 1">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.address_line_1 }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Address Line 2">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.address_line_2 }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="City"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.city }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="State"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.address_validated.state }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="Zipcode"> </kendo-label>
        <div class="detail-field__textbox">
          <span>{{
            detailsData.address_validated.zip4
              ? detailsData.address_validated.zip +
                '-' +
                detailsData.address_validated.zip4
              : detailsData.address_validated.zip
          }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="Participating">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.participating | booleanYesNo }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label
          class="detail-field__label"
          text="Certified/Decertified Date"
        >
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.certified_decertified_date }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="Start Date">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.ce_start_date }}</span>
        </div>
      </div>

      <div class="detail-field">
        <kendo-label class="detail-field__label" text="Termination Date">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.ce_termination_date }}</span>
        </div>
      </div>

      <div class="detail-field span-4">
        <kendo-label class="detail-field__label" text="Termination Reason">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.termination_reason }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label class="detail-field__label" text="Grant Number">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.grant_number }}</span>
        </div>
      </div>

      <div class="detail-field span-2">
        <kendo-label
          class="detail-field__label"
          text="Medicare Provider Number"
        >
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ detailsData.medicare_provider_number }}</span>
        </div>
      </div>

      <div class="detail-field span-4">
        <kendo-label class="detail-field__label" text="Medicaid Numbers">
        </kendo-label>
        <div class="detail-field__textbox">
          <span>{{ (detailsData.medicaid_numbers || []).join(', ') }}</span>
        </div>
      </div>
    </section>
  </ng-container>

  <kendo-dialog-actions class="container__toolbar">
    <div class="container__buttons">
      <button kendoButton class="container__button" (click)="close()">
        Cancel
      </button>
      <button
        kendoButton
        [primary]="true"
        class="container__button"
        (click)="save()"
        [disabled]="details.pending || !details.data || !npi"
      >
        Link
      </button>
    </div>
  </kendo-dialog-actions>
</div>
